import Box from '@mui/material/Box';

/**
 * USGSWaveLoader
 *
 * Animated USGS wave SVG loader used as a loading indicator.
 * Matches the common loader animation used across USGS web applications.
 */
export default function USGSWaveLoader() {
  return (
    <>
      <style>{`
        @keyframes wave-stroke-1 {
          0% { opacity: 0; stroke-dashoffset: 230.41px; stroke-dasharray: 230.41px; }
          10% { opacity: 1; }
          25% { stroke-dashoffset: 230.41px; stroke-dasharray: 230.41px; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 230.41px; }
          62% { opacity: 1; }
          80% { opacity: 0; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-2 {
          0% { opacity: 0; stroke-dashoffset: 214.17px; stroke-dasharray: 214.17px; }
          10% { opacity: 1; }
          25% { stroke-dashoffset: 214.17px; stroke-dasharray: 214.17px; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 214.17px; }
          62% { opacity: 1; }
          80% { opacity: 0; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-3 {
          0% { opacity: 0; stroke-dashoffset: 435.21px; stroke-dasharray: 435.21px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 435.21px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-4 {
          0% { opacity: 0; stroke-dashoffset: 435.42px; stroke-dasharray: 435.42px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 435.42px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-5 {
          0% { opacity: 0; stroke-dashoffset: 436.18px; stroke-dasharray: 436.18px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 436.18px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-6 {
          0% { opacity: 0; stroke-dashoffset: 437.33px; stroke-dasharray: 437.33px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 437.33px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-7 {
          0% { opacity: 0; stroke-dashoffset: 435.78px; stroke-dasharray: 435.78px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 435.78px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes wave-stroke-8 {
          0% { opacity: 0; stroke-dashoffset: 442.93px; stroke-dasharray: 442.93px; }
          10% { opacity: 1; }
          50% { stroke-dashoffset: 0; stroke-dasharray: 442.93px; }
          65% { opacity: 1; }
          100% { opacity: 0; }
        }
      `}</style>
      <Box
        role="status"
        aria-label="Loading"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          '& svg': {
            maxWidth: 120,
            maxHeight: 120,
          },
          '& path': {
            fill: 'none',
            stroke: '#016D4D',
            strokeWidth: 14,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 4,
          },
        }}
      >
        <svg
          width="392"
          height="306"
          viewBox="0 0 392 306"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M200.5 197.5C321 341 375 295 389.5 289.017" style={{ animation: 'wave-stroke-1 5s ease-in-out 0.28s infinite' }} />
          <path d="M200.5 202.5C334.5 312.5 375 253.5 389.5 247.517" style={{ animation: 'wave-stroke-2 5s ease-in-out 0.28s infinite' }} />
          <path d="M4 256.368C136.5 151 174.5 178.5 219 218.5C321 288.5 356.5 221.868 389.5 211.368" style={{ animation: 'wave-stroke-3 5s ease-in-out 0.3s infinite' }} />
          <path d="M4 214C96.0567 126.225 143.014 155.782 175.015 177.389C184.845 184.026 194.553 191.035 204.377 197.68C298.097 261.074 358.078 178.998 389.5 169" style={{ animation: 'wave-stroke-4 5s ease-in-out 0.25s infinite' }} />
          <path d="M4 174C151 63 138.5 215.5 267.5 200.5C311 189.5 340.5 154 389.5 129" style={{ animation: 'wave-stroke-5 5s ease-in-out 0.2s infinite' }} />
          <path d="M4 129C123 49.5 141.5 193 249 172.5C292.5 161.5 340.5 109 389.5 84" style={{ animation: 'wave-stroke-6 5s ease-in-out 0.15s infinite' }} />
          <path d="M4 92C106.5 65 128.5 165 218.5 154C262 143 288 101.5 389.5 47" style={{ animation: 'wave-stroke-7 5s ease-in-out 0.1s infinite' }} />
          <path d="M3.5 59C106.5 52.5 100.5 132.5 184 128.5C240 121 287.5 59 389 4.5" style={{ animation: 'wave-stroke-8 5s ease-in-out 0.05s infinite' }} />
        </svg>
      </Box>
    </>
  );
}
